import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center p-6 grain-bg" data-testid="payment-cancel-page">
      <div className="surface p-10 max-w-md text-center space-y-4">
        <XCircle className="w-14 h-14 text-charcoal-soft mx-auto" />
        <h1 className="text-2xl font-display font-bold text-eucalyptus-900">Checkout cancelled</h1>
        <p className="text-charcoal-soft">No charge was made. You can pick a plan whenever you're ready.</p>
        <Button data-testid="payment-cancel-billing" onClick={() => navigate("/billing")} className="bg-eucalyptus-900 hover:bg-eucalyptus-700 text-white">
          Back to Billing
        </Button>
      </div>
    </div>
  );
}
